export default __webpack_public_path__ + "static/media/active-weight.8e179b74.svg";